import { render } from "./CustomCheckBox.vue?vue&type=template&id=6ad827e4&scoped=true"
import script from "./CustomCheckBox.vue?vue&type=script&lang=js"
export * from "./CustomCheckBox.vue?vue&type=script&lang=js"

import "./CustomCheckBox.vue?vue&type=style&index=0&id=6ad827e4&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad827e4"]])

export default __exports__